module.exports = __webpack_public_path__ + "static/media/menu-icon.7597f54f.png";